import {Filtro} from './filtro';
import {RotaVo} from '~model/vo/rota-vo';
import {toNumber} from '~utils/time-utils';

export class FiltroHorarioInicio implements Filtro<RotaVo> {

  private comparadores: string[];

  constructor(
    comparadores: string[]
  ) {
    this.comparadores = comparadores;
  }

  filtrar(array: RotaVo[]): RotaVo[] {
    let resultado: RotaVo[] = [];
    const comparadoresNumbers = this.comparadores.map(comparador => toNumber(comparador));

    comparadoresNumbers.forEach(comparador => {
      resultado = resultado.concat(
        array.filter(obj => {
          const objRota = toNumber(obj.horaInicio);
          return objRota >= comparador;
        })
      );
    });

    return resultado;
  }

  getFiltroNome(): string {
    return 'horarioInicio';
  }

  getComparador(comparador: string): string {
    return this.comparadores.find(obj => obj === comparador) || '';
  }

  getComparadores(): string[] {
    return this.comparadores;
  }

  addComparador(comparador: string): void {
    this.comparadores = this.comparadores.concat(comparador);
  }

  addComparadores(comparadores: string[]): void {
    this.comparadores = this.comparadores.concat(comparadores);
  }

  setComparadores(comparadores: string[]): void {
    this.comparadores = comparadores;
  }

}
